(function () {
  'use strict';

  // Shared scroll-lock state across all section instances (only one drawer should be open at a time)
  var lockedScrollY = 0;
  var lockCount = 0;

  function lockBodyScroll() {
    lockCount++;
    if (lockCount > 1) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('cs-no-scroll');
    document.body.classList.add('cs-no-scroll');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }

  function unlockBodyScroll() {
    if (lockCount > 0) lockCount--;
    if (lockCount > 0) return;
    document.documentElement.classList.remove('cs-no-scroll');
    document.body.classList.remove('cs-no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  function initSection(root) {
    if (!root || root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';

    var grid = root.querySelector('.cs-grid');
    var cards = root.querySelectorAll('.cs-card');
    var checkboxes = root.querySelectorAll('.cs-filter-input');
    var emptyState = root.querySelector('.cs-empty');
    var sidebar = root.querySelector('.cs-sidebar');
    var overlay = root.querySelector('.cs-overlay');
    var toggleBtn = root.querySelector('.cs-filter-toggle');
    var closeBtn = root.querySelector('.cs-filter-close');
    var viewBtns = root.querySelectorAll('.cs-view-btn');
    var isOpen = false;
    var singleSelect = root.getAttribute('data-single-select') === 'true';

    // FILTERING
    function applyFilter() {
      var selected = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked) selected.push(cb.value);
      });

      var showAll = selected.length === 0;
      var visible = 0;

      cards.forEach(function (card) {
        var match = showAll || selected.indexOf(card.dataset.celeb) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });

      if (emptyState) {
        emptyState.hidden = visible !== 0;
      }
    }

    checkboxes.forEach(function (input) {
      input.addEventListener('change', function () {
        // SINGLE-SELECT MODE: if user just checked a box, uncheck every other one.
        // If they unchecked the only-checked box, nothing else to do (shows all).
        if (singleSelect && input.checked) {
          checkboxes.forEach(function (other) {
            if (other !== input && other.checked) {
              other.checked = false;
            }
          });
        }
        applyFilter();
      });
    });

    // DRAWER
    function openDrawer() {
      if (!sidebar || isOpen) return;
      isOpen = true;
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      lockBodyScroll();
    }
    function closeDrawer() {
      if (!sidebar || !isOpen) return;
      isOpen = false;
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      unlockBodyScroll();
    }
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Prevent touchmove on overlay from scrolling the page underneath on iOS
    if (overlay) {
      overlay.addEventListener('touchmove', function (e) {
        e.preventDefault();
      }, { passive: false });
    }

    // Reset drawer when crossing to desktop
    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        closeDrawer();
      }
    });

    // VIEW CHANGER
    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view');
        if (!view) return;
        if (grid) grid.setAttribute('data-view', view);
        viewBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.cs-wrapper').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.cs-wrapper');
    if (sec) initSection(sec);
  });
})();